<template>
  <div class="page_agencyRec">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
        <div class="flex">
          <el-form :inline="true" :model="listQuery" class="re_down_form declareForm" label-width="100px">
            <el-form-item label="项目名称" size="small">
              <el-select v-model="listQuery.objname" placeholder="" clearable filterable size="small" style="width:180px">
                 <el-option v-for="(item,index) in SelProNameList" :key="index"  :value="item"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="当前状态" size="small" v-if="activeName2 == '0'">
              <el-select v-model="listQuery.strbusistat" placeholder="" clearable filterable size="small" style="width:180px">
                <el-option value="合作中"></el-option>
                <el-option value="已暂停"></el-option>
                <el-option value="已终止"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="姓名" size="small" v-if="activeName2 == '1'">
              <el-input v-model="listQuery.strusername" size="small" clearable style="width:180px"></el-input>
            </el-form-item>
            <el-form-item label="联系方式" size="small" v-if="activeName2 == '1'">
              <el-input v-model="listQuery.strPhoneNum" size="small" clearable style="width:180px"></el-input>
            </el-form-item>
          </el-form>
          <div class="screenInput" v-if="activeName2 == '1'">
            <el-tooltip class="scr_icon" effect="dark" content="高级检索项" placement="top-start">
              <i class="i_txt" @click="dropDownScreen">{{ showDropScreen == 1 ? '收起' : '更多' }}<i class="el-icon-caret-bottom"></i></i>
            </el-tooltip>
          </div>
        </div>
      </div>
      <div class="top-right">
        <el-button v-if="showDropScreen == -1" v-preventReClick type="success" size="small" @click="searchHandle" style="margin-right: 15px;">搜索</el-button>
      </div>
    </div>
    <div class="r_dropDownScreen" v-show="showDropScreen == 1 && activeName2 == '1'">
      <div class="pro_down_box" style="padding-left: 33px">
        <el-form :inline="true" :model="listQuery" class="re_down_form declareForm" label-width="100px">
          <el-form-item label="入职时间:">
            <el-date-picker size="small" value-format="yyyy-MM-dd" v-model="listQuery.dtEntryBDate" type="date" style="width:180px" placeholder="选择开始时间">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="入职时间:">
            <el-date-picker size="small" value-format="yyyy-MM-dd" v-model="listQuery.dtEntryEDate" type="date" style="width:180px" placeholder="选择结束时间">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="离职时间:">
            <el-date-picker size="small" value-format="yyyy-MM-dd" v-model="listQuery.dtDepartBDate" type="date" style="width:180px" placeholder="选择开始时间">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="离职时间:">
            <el-date-picker size="small" value-format="yyyy-MM-dd" v-model="listQuery.dtEntryEDate" type="date" style="width:180px" placeholder="选择结束时间">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="入职岗位" size="small">
            <el-input v-model="listQuery.strJobInf" size="small" clearable style="width:180px"></el-input>
          </el-form-item>
          <el-form-item label="推荐渠道:">
            <el-select v-model="listQuery.PushName" placeholder="" size="small" filterable clearable style="width:180px">
              <el-option value="宁波网招"></el-option>
              <el-option value="社招推荐人"></el-option>
              <el-option value="网招中心"></el-option>
              <el-option value="公司渠道"></el-option>
              <el-option value="校招部"></el-option>
              <el-option value="业务项目部"></el-option>
              <el-option value="招聘部"></el-option>
              <el-option value="客服部"></el-option>
              <el-option value="小杰门店"></el-option>
              <el-option value="企业转移"></el-option>
              <el-option value="员工内荐"></el-option>
              <el-option value="供应商"></el-option>
              <el-option value="其他情况"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="推荐渠道备注:">
            <el-input v-model="listQuery.PushRemark" size="small" clearable style="width:180px"></el-input>
          </el-form-item>
          <el-form-item label="当前状态:">
            <el-select v-model="listQuery.StrWorkState" size="small" filterable clearable placeholder="" style="width: 180px;">
              <el-option label="全部" value="">
              </el-option>
              <el-option value="在职">
              </el-option>
              <el-option value="离职">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <div class="drop-footer">
        <el-button size="small" type="info" plain @click="showDropScreen = -1">关闭</el-button>
        <el-button size="small" type="success" @click="getList">搜索</el-button>
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>雇员</el-breadcrumb-item>
          <el-breadcrumb-item>面试入职流程</el-breadcrumb-item>
          <el-breadcrumb-item>代理招聘</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="ftabs">
        <ResourceComTabs ref="child" :active="activeName" :btnAuth="permissionLists" @change="currChange($event)">
        </ResourceComTabs>
        <el-tabs v-model="activeName2" @tab-click="changeTab2" style="margin:0 20px;">
          <el-tab-pane label="项目" name="0"></el-tab-pane>
          <el-tab-pane label="人员" name="1"></el-tab-pane>
        </el-tabs>

        <div style="padding: 10px;" class="flex">
          <el-button type="success" size="small" v-if="checkPermission(['tab_PRO_entrySign'], permissionLists)" v-preventReClick @click="handleSign('entry')">代理招聘入职登记</el-button>
          <el-button type="danger" size="small" v-if="checkPermission(['tab_PRO_qquitSign'], permissionLists)" v-preventReClick @click="handleSign('quit')">代理招聘离职登记</el-button>
          <el-button type="primary" size="small" v-if="checkPermission(['tab_PRO_export'], permissionLists)" v-preventReClick :loading="exportLoading" @click="expList()">&nbsp;导 出</el-button>
        </div>

        <el-table :data="tableData" border class="doc_table" v-loading="loading" style="width:100%">
          <template v-for="(item, index) in tableTitle">
            <el-table-column :prop="item.StrColumId" :label="item.StrColumName" fit show-overflow-tooltip :key="index" :min-width="item.StrColumName=='序号' ? '50px' : '140px'" align="center">
              <template slot-scope="scope">
                {{ scope.row[item.StrColumId] }}
              </template>
            </el-table-column>
          </template>
        </el-table>
        <div class="block">
          <el-pagination v-if="totalCount>0" @current-change="currentChange" :current-page.sync="listQuery.currpage" :page-size="Number(listQuery.pagecount)" @size-change="handleSizeChange" :page-sizes="[10,20, 50, 100, 200]" layout="total,sizes,prev,pager, next, jumper" :total="totalCount"></el-pagination>
        </div>
      </div>
    </div>

    <!-- 入离职登记弹框 -->
    <el-dialog :title="type=='entry' ? '代理招聘入职登记' : '代理招聘离职登记'" :visible.sync="handleVisible" width="800px" class="res_dialog">
      <el-form :model="handleForm" :rules="rules" ref="handleForm" :inline="true" label-width="125px">
        <el-form-item label="姓名" prop="StrEmpName">
          <el-input v-model="handleForm.StrEmpName" size="small" style="width:180px"></el-input>
        </el-form-item>
        <el-form-item label="联系方式" prop="StrPhoneNum">
          <el-input v-model="handleForm.StrPhoneNum" size="small" style="width:180px"></el-input>
        </el-form-item>
        <div class="flex">
          <el-form-item label="项目名称" size="small" prop="StrObjName">
            <el-select v-model="handleForm.Projectid" placeholder="" clearable filterable size="small" style="width:180px" @change="changeObj">
              <el-option v-for="item in proNameList" :key="item.Id" :label="item.StrprojectName" :value="item.StrprojectName"></el-option>
            </el-select>
          </el-form-item>
          <div class="huo">或</div>
          <el-input v-model="handleForm.StrObjName" @blur="inputObj" placeholder="手工填写" size="small" style="width:180px"></el-input>
        </div>
        <el-form-item label="入职时间" prop="DtEntryBdate" v-if="type=='entry'">
          <el-date-picker size="small" value-format="yyyy-MM-dd" v-model="handleForm.DtEntryBdate" type="date" style="width:180px" placeholder="">
          </el-date-picker>
        </el-form-item>

        <el-form-item label="离职时间" prop="DtDepartureDate" v-if="type=='quit'">
          <el-date-picker size="small" value-format="yyyy-MM-dd" v-model="handleForm.DtDepartureDate" type="date" style="width:180px" placeholder="">
          </el-date-picker>
        </el-form-item>

        <el-form-item label="身份证号码" v-if="type=='entry'">
          <el-input v-model="handleForm.StrIdCard" size="small" style="width:180px"></el-input>
        </el-form-item>

        <div class="flex" v-if="type=='entry'">
          <el-form-item label="入职岗位" size="small">
            <el-select v-model="handleForm.StrJobInf" placeholder="" clearable filterable size="small" style="width:180px" @change="changeJob">
              <el-option v-for="(item, index) in jobList" :key="index" :label="item.CustomerJobName" :value="item.Id">
              </el-option>
            </el-select>
          </el-form-item>
          <div class="huo">或</div>
          <el-input v-model="handleForm.StrJobInf" placeholder="手工填写" size="small" style="width:180px"></el-input>
        </div>
        <el-form-item label="推荐渠道:" v-if="type=='entry'">
          <el-select v-model="handleForm.PushName" placeholder="" size="small" filterable clearable style="width:180px">
            <el-option value="宁波网招"></el-option>
            <el-option value="社招推荐人"></el-option>
            <el-option value="网招中心"></el-option>
            <el-option value="公司渠道"></el-option>
            <el-option value="校招部"></el-option>
            <el-option value="业务项目部"></el-option>
            <el-option value="招聘部"></el-option>
            <el-option value="客服部"></el-option>
            <el-option value="小杰门店"></el-option>
            <el-option value="企业转移"></el-option>
            <el-option value="员工内荐"></el-option>
            <el-option value="供应商"></el-option>
            <el-option value="其他情况"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="推荐渠道备注:" v-if="type=='entry'">
          <el-input v-model="handleForm.PushRemark" size="small" clearable style="width:180px"></el-input>
        </el-form-item>
        <el-form-item label="入职备注:" v-if="type=='entry'">
          <el-input v-model="handleForm.StrEntryRemark" size="small" clearable style="width:180px"></el-input>
        </el-form-item>
        <el-form-item label="离职备注:" v-if="type=='quit'">
          <el-input v-model="handleForm.StrDepartRemark" size="small" clearable style="width:180px"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleVisible = false" size="small">取 消</el-button>
        <el-button type="primary" v-preventReClick style="margin-left:10px;" @click="confirmSubmit" size="small" :loading="isBtnLoading">确 认</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import xz from "../../common";
  import FUN from "../../fun";
  import checkPermission from '@/utils/permission' // 权限判断函数
  import ResourceComTabs from "./components/resourceComTabs.vue";
  export default {
    components: {
      ResourceComTabs
    },
    data() {
      return {
        listQuery: {
          currpage: 1,
          pagecount: 10,
          objname: '',
          strbusistat: '', //状态
        },
        totalCount: 0,
        activeName: '代理招聘',
        roletype: localStorage.loginRoletype,
        showDropScreen: -1,
        loading: false,
        exportLoading: false,
        tableTitle: [], //表头
        tableData: [],
        proNameList: [], //入职的项目列表
        selProNameList: [], //查询时的项目列表
        activeName2: '0',
        permissionLists: [],
        handleVisible: false,
        type: 'entry',
        isBtnLoading: false,
        // 按钮权限参数
        butQuery: {
          path: '/signupList',
          powerEnName: 'employee'
        },
        jobList: [],
        handleForm: {
          Projectid: '', // 项目ID
          StrObjName: '', // 项目名称
          StrEmpName: '', // 雇员姓名
          StrPhoneNum: '', // 联系方式
          DtEntryBdate: '', // 入职时间
          StrIdCard: '', // 身份证号
          Jobid: '', // 岗位ID
          StrJobInf: '', // 岗位信息
          StrEntryRemark: '', // 入职备注
          PushName: '', // 推荐渠道
          PushRemark: '' // 推荐渠道备注
        },
        rules: {
          StrEmpName: {
            required: true,
            message: '请填写姓名'
          },
          StrPhoneNum: {
            required: true,
            message: '请填写联系方式'
          },
          StrObjName: {
            required: true,
            message: '请填写项目名称'
          },
          DtEntryBdate: {
            required: true,
            message: '请选择入职时间'
          },
          DtDepartureDate: {
            required: true,
            message: '请选择离职时间'
          },
        },
      }
    },
    created() {
      this.getTableHead();
      this.getProList();
      this.getSelProList();
      this.getButtonPower();
    },
    methods: {
      checkPermission,
      // 获取按钮权限
      getButtonPower() {
        let that = this;
        xz.getbtnPowerIdBypage(this.butQuery).then((res) => {
          // console.log('按钮',res)
          if (res.status == "ok") {
            let resmsg = res.msg;
            if (!this.isNull(resmsg)) {
              for (let index = 0; index < resmsg.length; index++) {
                let element = resmsg[index];
                this.permissionLists.push(element.Enname);
              }
            } else {
              this.permissionLists = [];
            }
          } else {
            this.permissionLists = [];
          }
        });
      },
      //筛选下拉
      dropDownScreen() {
        if (this.showDropScreen == -1) {
          this.showDropScreen = 1;
        } else if (this.showDropScreen == 1) {
          this.showDropScreen = -1;
        }
      },
      //获取项目
      getSelProList() {
        let data = {
          pagecount: 100000000,
          currpage: 1,
        }
        xz.SelFun(data, 'edit', 'SelProjectrpo').then((res) => {
          if (res.status == "ok") {
            this.SelProNameList = res.msg.data;
          } else {
            this.SelProNameList = [];
          }
        });
      },
      //获取项目
      getProList() {
        let data = {
          projectname: "", // 项目名称
          projectid: "", // 项目id
          custname: "", //客户名称
          strAchieveowner: "", // 业绩归属人
          strservuserid: "", // 客服
          strBusiStat: "", //项目状态
          strpartner2: "", //合伙人
          perpage: 100000000,
          currpage: 1,
          strorgancode: "",
          roletype: this.roletype,
        }
        xz.getProjectLists(data).then((res) => {
          if (res.status == "ok") {
            this.proNameList = res.msg;
          } else {
            this.proNameList = [];
          }
        });
      },
      searchHandle() {
        this.listQuery.currpage = 1;
        this.getList();
      },
      //获取表头
      getTableHead() {
        let tableid = this.activeName2 == '0' ? 'JB_base_Projectrpoout' : 'JB_emp_UserAgent';
        xz.getJbbasePageColumnList(tableid, '').then(res => {
          if (res.status == 'ok') {
            this.tableTitle = res.msg
            this.getList()
          } else {
            this.tableTitle = []
          }
        })
      },
      //获取列表
      getList() {
        this.loading = true;
        let pagename = this.activeName2 == '0' ? 'ByProjectrpo' : 'ByPersonrpo'
        xz.SelFun(this.listQuery, 'edit', pagename).then(res => {
          if (res.status == 'ok') {
            if (this.activeName2 == '0') {
              this.tableData = res.msg.data;
              this.totalCount = res.totalcount;
            } else {
              this.tableData = res.data;
              this.totalCount = res.count;
            }
            this.loading = false;
          } else {
            this.loading = false;
            this.$message.error(res.msg);
            this.tableData = [];
          }
        })
      },
      currentChange(val) {
        this.listQuery.currpage = Number(val);
        this.getList();
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.listQuery.currpage = 1;
        this.listQuery.pagecount = val;
        this.getList();
      },
      // 子组件传值
      async currChange(value) {},
      changeTab2() {
        if (this.activeName2 == '0') {
          this.listQuery = {
            currpage: 1,
            pagecount: 10,
            objname: this.listQuery.objname,
            strbusistat: '', //状态
          }
        } else {
          this.listQuery = {
            currpage: 1,
            pagecount: 10,
            objname: this.listQuery.objname,
            strusername: '', //姓名
            strPhoneNum: '', //联系方式
            strJobInf: '', //
            dtEntryBDate: '', //入职时间
            dtEntryEDate: '', //
            dtDepartBDate: '', //
            dtDepartEDate: '', //离职时间
            PushName: '', //
            PushRemark: '', //
            StrWorkState: '', //
          }
        }
        this.getTableHead();
      },
      //导出列表
      expList() {
        this.exportLoading = true;
        let d = JSON.parse(JSON.stringify(this.listQuery));
        d.pagecount = 10000;
        xz.OutputByRpo(d, this.activeName2 == '0' ? 'JB_base_Projectrpoout' : 'JB_emp_UserAgent').then(res => {
          if (res.status == "ok") {
            var path = this.$store.state.EMP.tablePath + res.msg
            let aTag = document.createElement('a')
            aTag.href = path
            aTag.click();
            this.exportLoading = false;
          } else {
            this.exportLoading = false;
            this.$message.error(res.msg)
          }
        });
      },
      handleSign(type) {
        this.type = type;
        if (type == 'entry') {
          this.handleForm = {
            Projectid: '', // 项目ID
            StrObjName: '', // 项目名称
            StrEmpName: '', // 雇员姓名
            StrPhoneNum: '', // 联系方式
            DtEntryBdate: '', // 入职时间
            StrIdCard: '', // 身份证号
            Jobid: '', // 岗位ID
            StrJobInf: '', // 岗位信息
            StrEntryRemark: '', // 入职备注
            PushName: '', // 推荐渠道
            PushRemark: '' // 推荐渠道备注}
          }
        } else {
          this.handleForm = {
            Projectid: '',
            StrObjName: '',
            StrEmpName: '',
            StrPhoneNum: '',
            DtDepartureDate: '',
            StrDepartRemark: ''
          }
        }
        this.handleVisible = true;
      },
      //判断是否为空(包含0)
      isNull(o) {
        return o == undefined || o == "undefined" || (o + '').indexOf("undefined") > -1 || o == null || o == '' || o == 'null' || o == [] || o == 0 || o == 'NaN' || o == ('1900-01-01') || o == '1900-01-01T00:00:00';
      },
      changeObj(val) {
        if (val) {
          let item = this.proNameList.find(item => item.Projectid == val);
          this.handleForm.StrObjName = item.StrprojectName;
          xz.getresourcejobcustomerlist(localStorage.loginRoletype, {
            projectid: val
          }).then(res => {
            if (res.status == 'ok') {
              this.jobList = res.data;
            }
          })
        }
      },
      inputObj() {
        this.handleForm.Projectid = '';
      },
      changeJob(val) {
        if (val) {
          let item = this.jobList.find(item => item.Id == val);
          this.handleForm.StrJobInf = item.CustomerJobName;
        }
      },
      inputJob() {
        this.handleForm.Jobid = '';
      },
      confirmSubmit() {
        this.$refs["handleForm"].validate((valid) => {
          if (valid) {
            this.isBtnLoading = true;
            let pagename = this.type == 'entry' ? 'AddEntryPersonrpo' : 'AddDepartPersonrpo'
            xz.SelFun(this.handleForm, 'save', pagename).then(res => {
              if (res.status == 'ok') {
                this.$message.success('操作成功！');
                this.getList();
                this.isBtnLoading = false;
                this.handleVisible = false;
              } else {
                this.$message.error(res.msg);
                this.getList();
                this.isBtnLoading = false;
              }
            })
          }
        })
      },
    }
  }
</script>

<style lang="scss" scoped>
  .ftabs {
    background: #fff;
    padding: 0px 16px 16px;
    margin-bottom: 16px;
  }

  .scr_icon.i_txt {
    display: inline-block;
    font-size: 12px;
    cursor: pointer;
  }

  .r_dropDownScreen {
    width: 100%;
    box-sizing: border-box;
    background-color: #fff;
  }

  .huo {
    font-size: 16px;
    margin: 0 20px 0 10px;
    line-height: 32px;
  }
</style>
<style>
  .page_agencyRec .eleTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_agencyRec .doc_table .el-table__body td.el-table__cell {
    padding: 5px 0;
  }

  .page_agencyRec .doc_table .el-table__body th.el-table__cell {
    padding: 8px 0;
  }

  .page_agencyRec .el-input__icon {
    height: 32px;
    line-height: 32px;
  }

  .page_agencyRec .el-input-group__append,
  .el-input-group__prepend {
    padding: 0 10px;
    background: #fff;
  }

  .page_agencyRec .declareForm .el-form-item {
    margin-bottom: 10px;
  }

  .page_agencyRec .declareForm .el-form-item__error {
    top: 34px;
  }
</style>